import { ViewModel,View } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { warehouseFloorSelectorViewModel } from "../warehouseFloorManipulation/warehouseFloorManipulation-viewModel";
import  { GetCurrentWarehouseFloorView } from "./getCurrentWarehouseFloor-view"

export class GetCurrentWarehouseFloorViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'ثبت طبقه کنونی';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.FloorSelector = new warehouseFloorSelectorViewModel(this);
        this.setFloor(localStorage.getItem("currentFloorId"));
    }

    GetDefaultView(): View <ViewModel> {
        return new GetCurrentWarehouseFloorView();
    }
    public getTypeId(): string {
        return "VM-7F0BE631-A5BF-4DFD-AD80-B9BB33A97DD5"
    }

    public set FloorSelector(v: warehouseFloorSelectorViewModel) { this._FloorSelector = v; } public get FloorSelector(): warehouseFloorSelectorViewModel { return this._FloorSelector;} private _FloorSelector: warehouseFloorSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    getFloor() {
        return this.FloorSelector.selectedItem?.id;
    }

    setFloor(id:string) {
        this.FloorSelector.selectById(id);
    }

    getFloorName() {
        return this.FloorSelector.selectedItem?.title;
    }

    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.getFloor())){
            result.push('طبقه مشخص نشده است.')
        }
        return result;
    }

    async remove(){
        localStorage.removeItem("currentFloorId");
        localStorage.removeItem("currentFloorName");
        this.setFloor(null);
        await this.messageBoxConfirmSuccess("طبقه سیستم کنونی حذف شد.",'عملیات موفق');
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت طبقه');
                return;
            }
            this.isLoading = true;
            localStorage.setItem("currentFloorId", this.getFloor());
            localStorage.setItem("currentFloorName", this.getFloorName());
            await this.messageBoxConfirmSuccess("طبقه سیستم کنونی ثبت شد.",'عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

}
